import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TransactionIdWithNotification } from '../TxIdWithNotification/TransactionIdWithNotification';
import { getExplorerUrl } from 'utils/common';
export const TransactionIdRenderer = ({ hash, chainId, }) => {
    const href = chainId === 'BTC'
        ? `https://mempool.space/testnet/tx/${hash}`
        : getExplorerUrl(Number(chainId), hash, 'tx');
    return (_jsx(TransactionIdWithNotification, { href: href, value: hash, className: "text-primary-20 hover:no-underline", startLength: 5, endLength: 4 }));
};
